<template>
    <div class="role_warp">
        <div class="item_warp">
          <el-date-picker
          v-model="dataTime"
          type="daterange"
          value-format="yyyy-MM-dd"
          style="margin-right: 10px"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
          <el-button
          type="primary"
          class="edit-button"
          size="mini"
          @click="select()"
          >筛选</el-button
        >
      </div>
      <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px">域名</label>
        <el-input
          v-model="investId"
          placeholder="请输入域名"
          style="width: 170px"
          size="mini"
          clearable
        />
      </div>
    </div>

      <!-- 表单 -->
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        height="calc(100vh - 240px )"
        style="width: 401px;margin-top: 10px"
        size="mini"
      >
      <el-table-column prop="enDate" label="时间" width="150">
          <template slot-scope="scope">
            <div>{{ happenTimeFun(scope.row.date) }}</div>
          </template>
       </el-table-column> 
       <el-table-column prop="domain" label="域名" width="150" />
       <el-table-column prop="ipCount" label="访问IP数" width="100" />
      </el-table>
      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="getRoleinfo"
      />
       <!-- 下级团队 -->
    <el-dialog
      :visible.sync="dialogVisible2"
      width="740px"
      title="投入详情"
      :center="true"
      :close-on-click-modal="false"
    >
      <div>
        <el-table
          ref="gridTable"
          v-loading="loading1"
          :data="childrenSum2"
          tooltip-effect="dark"
          :stripe="true"
          :border="true"
          height="540px"
          style="width: 671px"
          size="mini"
        >
          <el-table-column prop="memberUid" label="用户uid" width="100" />
          <el-table-column prop="grid" label="投入格子" width="100" />
          <el-table-column prop="amount" label="投入金额" width="100" />
          <el-table-column prop="financialDay" label="状态" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.result == 0" style="color:red">输</div>
            <div v-if="scope.row.result == 1" style="color:#68CD86">赢</div>
          </template>
        </el-table-column> 
          <el-table-column prop="rewardAmount" label="奖励金额" width="100" />
          <el-table-column prop="createDate" label="创建时间" width="170" />
        </el-table>
      </div>
    </el-dialog>
    </div>
  </template>
  <script>
  import Pagination from "@/components/Pagination"; // 引入分页器
  import validEmail from "@/utils/validate"; // 引入邮箱验证方法
  import md5 from "js-md5"; // 引入Md5加密
  
  export default {
    name: "Management",
    components: { Pagination },
    data() {
      return {
        tableData: [], // 展示的表单信息
        total: 0, // 总数
        pageNum: 1, // 页码值
        pageSize: 20, // 页大小
        loading: false, // 表格加载
        dialogVisible2: false,
        dataTime: ["", ""],
        startDate: "",
        childrenSum2:[],
        endDate: "",
        investId: "",
        sn: "",
        loading1:false
      };
    },
    created() {
      let time = +new Date();
      let time1 = +new Date() - 7 * 24 * 60 * 60 * 1000;
      this.dataTime[0] = this.happenTimeFun(time1);
      this.dataTime[1] = this.happenTimeFun(time);
    },
    mounted() {
      this.getRoleinfo();
    },
    methods: {
    getChildrenSum(row) {
      this.active = row;
      this.dialogVisible2 = true;
      this.$api.operate
        .escapeRecordBuyList({
            sn: this.active.sn,
        })
        .then((res) => {
          if (res) {
            this.childrenSum2 = res;
          }
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
      happenTimeFun(num) {
        let date = new Date(num);
        //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM; //月补0
        let d = date.getDate();
        d = d < 10 ? "0" + d : d; //天补0
        let h = date.getHours();
        h = h < 10 ? "0" + h : h; //小时补0
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m; //分钟补0
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s; //秒补0
        return y + '-' + MM + '-' + d;
      },

      // 筛选
      select() {
        this.pageNum = 1;
        this.getRoleinfo();
      },
      // 获取表单信息
      getRoleinfo() {
        var params = {
          pageNumber: this.pageNum,
          pageSize: this.pageSize,
          startDate: this.dataTime[0],
          endDate: this.dataTime[1],
          domain:this.investId
        };
        this.loading = true;
        this.$refs.gridTable.bodyWrapper.scrollTop = 0;
        this.$api.operate
          .adDomainData(params)
          .then((res) => {
            this.tableData = res;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .role_warp {
  width: 100%;
  overflow: hidden;
    font-size: 14px;
    padding: 10px;
    box-sizing: border-box;
    .role_heard_tool {
      margin-bottom: 10px;
    }
    .edit_titile {
      .dialog_input {
        // width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 70%;
        span {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          margin-right: 20px;
        }
        .el-input {
          flex: 3;
        }
      }
    }
    .tree {
      margin-top: 25px;
      display: flex;
      justify-content: space-around;
    }
    .authority_info {
      margin-top: 25px;
    }
  }
  .el-input {
    width: 70%;
  }
  </style>
  